/* 
https://www.iconfinder.com/icons/1243689/call_phone_icon
Creative Commons (Attribution 3.0 Unported);
https://www.iconfinder.com/Makoto_msk */

export const storeProducts = [
  {
    id: 1,
    title: "Apple MacBook Pro (16GB RAM, 512GB Storage, 2.2GHz Intel Core i7) - Silver",
    img: "img/product-1.png",
    price: 1299,
    company: "APPLE",
    info:
      "MacBook Pro has an eighth-generation Intel 6-core processor for up to 70 percent faster compute speeds.1 A brilliant and colorful Retina display. A 1.4GHz quad-core 8th-generation Intel Core i5 processor Turbo Boost up to 3.9GHz Intel Iris Plus Graphics 645. 8GB 2133MHz LPDDR3 memory 128GB SSD storage. Retina display with True Tone. Touch Bar and Touch ID. Two Thunderbolt 3 ports",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 2,
    title: "HUAWEI P30 PRO",
    img: "img/product-2.png",
    price: 855,
    company: "HUAWEI",
    info:
      "The Huawei P30 Pro is a camera beast that sets a benchmark for mobile photography. It also offers flagship performance making it one of the best phones to buy right now. The Huawei P30 Pro offers the best imaging performance on a smartphone available today. The low light capabilities without using a specialized shooting mode is unrivalled. The 5x telephoto lens is one of a kind and would be of great interesting to anyone who’s an avid traveller.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 3,
    title: "SONY WH-1000XM3 NOISE-CANCELLING HEADPHONES - BESTSELLER",
    img: "img/product-3.png",
    price: 300,
    company: "SONY",
    info:
      "Sony's WH-1000XM3, the third generation of Sony's excellent wireless noise-canceling headphones, has a more comfortable fit and features even better performance than its predecessor, perfect for listening to music. With a strong battery life, these over-ear headphones are currently our top-rated pick for the best headphones for noise cancelling, slightly edging out the Bose Noise Cancelling Headphones 700, which are more expensive.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 4,
    title: "ONEPLUS 7T PRO",
    img: "img/product-4.png",
    price: 750,
    company: "ONEPLUS",
    info:
      "OnePlus 7T Pro offers powerful performance, smooth 2K display and good cameras. The OnePlus flagship comes equipped with 12GB RAM and 256GB storage so memory is not an issue. The smartphone runs on the latest silicon from Qualcomm. Hence, performance-wise it is a beast as well. The OnePlus 7T Pro comes for 50k and is one of the best mobile phones one can buy right now.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 5,
    title: "HTC Desire 626s",
    img: "img/product-5.png",
    price: 94,
    company: "HTC",
    info:"The HTC Desire 626  comes with a 5.00-inch touchscreen display with a resolution of 720x1280 pixels at a pixel density of 294 pixels per inch (ppi). HTC Desire 626 is powered by a 1.2GHz quad-core Qualcomm Snapdragon 410 processor. It comes with 1GB of RAM. The phone runs Android and is powered by a 2000mAh non-removable battery.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 6,
    title: "Iphone 5s",
    img: "img/product-6.png",
    price: 365,
    company: "apple",
    info: "Apple iPhone 5s smartphone was launched in September 2013. The phone comes with a 4.00-inch touchscreen display with a resolution of 640x1136 pixels at a pixel density of 326 pixels per inch (ppi) and an aspect ratio of 16:9. Apple iPhone 5s is powered by a 1.3GHz dual-core Apple A7 processor. It comes with 1GB of RAM. The Apple iPhone 5s runs iOS 7 and is powered by a 1570mAh non-removable battery.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 7,
    title: "Iphone 7",
    img: "img/product-7.png",
    price: 499,
    company: "apple",
    info:
      "iPhone 7 is a decisive statement about the future. The dual cameras on the iPhone 7 Plus promise to usher in a new era in mobile photography. The iconic iPhone home button is no longer a physical button, but instead a sophisticated ballet of pressure sensors and haptic vibration motors that simulate the feel of a button. The new A10 Fusion processor blends two high-power cores that rival laptop performance with two low-power cores that combine with a much larger battery to extend run time by up to two hours.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 8,
    title: "Mastering Bitcoin",
    img: "img/product-8.png",
    price: 49,
    company: "Andreas M. Antonopoulos",
    info:
      "Mastering Bitcoin is essential reading for everyone interested in learning about bitcoin basics, the technical operation of bitcoin, or if you're building the next great bitcoin killer app or business. From using a bitcoin wallet to buy a cup of coffee, to running a bitcoin marketplace with hundreds of thousands of transactions, or collaboratively building new financial innovations that will transform our understanding of currency and credit, this book will help you engineer money. You're about to unlock the API to a new economy. This book is your key. This book will help you learn everything you need to know about decentralized digital money, which is one of the most exciting technical revolutions in decades.",
    inCart: false,
    count: 0,
    total: 0
  }
];

export const detailProduct = {
  id: 1,
  title: "Google Pixel - Black",
  img: "img/product-1.png",
  price: 10,
  company: "google",
  info:
    "Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
  inCart: false,
  count: 0,
  total: 0
};
